export const GET_PREDICT_DISEASE_SUCCESS = 'GET_PREDICT_DISEASE_SUCCESS'
export const GET_PREDICT_DISEASE_FAIL = 'GET_PREDICT_DISEASE_FAIL'
export const GET_PREDICT_DISEASE_CLEAR_DATA = 'GET_PREDICT_DISEASE_CLEAR_DATA'
